import React from 'react';

import { Section } from '../..';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const ExpectedSalary = ({ field, translations }) => {
    const renderedSection = checkSectionCondition(field.value);

    return (
        <Section.Conditional
            condition={Boolean(field.order) && renderedSection}
            title={translations.salary}
        >
            {({ renderField }) => (
                renderField(translations.salaryLabel, field.textAnswer)
            )}
        </Section.Conditional>
    );
};

ExpectedSalary.propTypes = defaultPropTypes;

export default ExpectedSalary;
